import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltipWord: {
      marginLeft: '4px',
      marginRight: '4px',
      textDecoration: 'underline',
      color: colors.resiliaBlue,
      fontWeight: 700,
      '&:hover': {
        color: `${colors.darkBlue} !important`,
        cursor: 'default',
      },
    },
    tooltipLastWord: { marginRight: '0px !important' },
    tooltipFirstWord: { marginLeft: '0px !important' },
  })
)

export default useStyles
